import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { checkoutGridProps } from "@store/theme/common/props/checkout";
import React, { FC } from "react";

interface Props extends WidgetProps {}

export interface OrderApprovalDetailsPageContainerStyles {
    gridContainer?: GridContainerProps;
    mainGridItem?: GridItemProps;
    sideGridItemMobile?: GridItemProps;
    sideGridItemDesktop?: GridItemProps;
}

export const orderApprovalDetailsPageContainerStyles: OrderApprovalDetailsPageContainerStyles = {
    gridContainer: checkoutGridProps.container,
    mainGridItem: checkoutGridProps.mainColumn,
    sideGridItemMobile: checkoutGridProps.sideColumnMobile,
    sideGridItemDesktop: checkoutGridProps.sideColumnDesktop,
};

const styles = orderApprovalDetailsPageContainerStyles;

const OrderApprovalDetailsPageContainer: FC<Props> = ({ id }) => {
    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.sideGridItemMobile}>
                <Zone zoneName="Content1" contentId={id} />
            </GridItem>
            <GridItem {...styles.mainGridItem}>
                <Zone zoneName="Content0" contentId={id} />
            </GridItem>
            <GridItem {...styles.sideGridItemDesktop}>
                <Zone zoneName="Content1" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: OrderApprovalDetailsPageContainer,
    definition: {
        group: "Order Approval Details",
        displayName: "Page Container",
        allowedContexts: ["OrderApprovalDetailsPage"],
    },
};

export default widgetModule;
